
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.2818 6.18002C10.845 6.05918 11.4216 5.99877 12 6.00002C17.7273 6.00002 21 12 21 12C20.5033 12.8517 19.911 13.6536 19.2327 14.3925M13.7345 13.59C13.5098 13.8111 13.2388 13.9884 12.9378 14.1113C12.6367 14.2343 12.3116 14.3005 11.9821 14.3058C11.6525 14.3111 11.3251 14.2555 11.0195 14.1424C10.7139 14.0292 10.4362 13.8608 10.2031 13.6471C9.97007 13.4335 9.78632 13.179 9.66287 12.8988C9.53942 12.6186 9.47879 12.3185 9.48461 12.0164C9.49042 11.7143 9.56256 11.4164 9.69672 11.1404C9.83087 10.8644 10.0243 10.616 10.2655 10.41M16.86 16.455C15.4614 17.4323 13.7584 17.9736 12 18C6.27273 18 3 12 3 12C4.01773 10.2614 5.42929 8.74247 7.14 7.54502L16.86 16.455Z","stroke":"#10001F","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3 3L21 21","stroke":"#10001F","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    